class RegionRestrictions{
	constructor(){
		this.restrictions = {};
	}
	updateRestrictions(data){
		if(data instanceof RegionRestrictions)
		{
			return data;
		}
		for(let ladderId in data){
			if(!data.hasOwnProperty(ladderId))
			{
				continue;
			}
			let restriction = data[ladderId];
			this.restrictions[ladderId] = new RegionRestriction(restriction, ladderId);
		}
		return this;
	}
	retrieveRestrictions(ladderId){
		if(this.restrictions[ladderId])
		{
			return this.restrictions[ladderId];
		}
		return new RegionRestriction({}, ladderId);
	}
}
class RegionRestriction
{
	constructor(data, ladderId){
		this.ladderId = parseInt(ladderId);
		this.continent = data.continent;
		this.country = data.country;
		this.state = data.state;
		this.chat_room_id = data.chat_room_id;
	}

	static types(currentChatRoom){
		let types = [
			{
				field: 'continent',
				descriptor: 'Restrict Search by Continent',
			},
			{
				field: 'country',
				descriptor: 'Restrict Search by Country',
			},
			{
				field: 'state',
				descriptor: 'Restrict Search by State',
			},
		];
		if(currentChatRoom)
		{
			types.push({
				field: 'chat_room_id',
				value: currentChatRoom.id,
				description: 'Restrict Search to others within chat '+currentChatRoom.name,
			})
		}
		return types;
	}

	createElements(){
		let elements = [];
		for(let field of RegionRestriction.types()){
			let element = this.createElement(field);
			elements.push(element);
		}
		return elements;
	}

	createElement(field){
		let element = RegionRestriction.template.clone();
		element.removeClass('restriction_field').addClass('restriction_'+field.field);
		element.attr('data-ladder_id', this.ladderId);
		let checkbox = element.find('input[type=checkbox]').attr('name',field.field);
		if(this[field.field])
		{
			checkbox.prop('checked', true);
		}
		element.find('.title_description').text(field.descriptor);
		return element;
	}

}
RegionRestriction.template = $('#region_restriction_template').detach().attr('id','');

export {RegionRestrictions};